export default (state, pusher) => {
    state.pusher = pusher;
}


// WEBPACK FOOTER //
// ./src/app/store/users/mutations/set-pusher.js